import type { LifeWheelScores, LifeWheelTopic } from "../types";

export const LIFE_WHEEL_TOPICS: LifeWheelTopic[] = [
  "emotional",
  "spiritual",
  "intellectual",
  "serving",
  "relatives",
  "family",
  "marital",
  "health",
  "professional",
  "academic",
  "financial",
  "social",
];

export const LIFE_WHEEL_MAX_SCORE = 10;

/** A radar polygon needs at least 3 axes. */
export const MIN_CHART_TOPICS = 3;

export interface ChartTopic {
  topic: LifeWheelTopic;
  current: number;
  target: number;
}

/**
 * Topics shown in the radar chart, in the canonical order. A topic rated 0 for
 * both "current" and "in 1 year" (or never rated) is left out.
 */
export const getChartTopics = (scores: LifeWheelScores = {}): ChartTopic[] =>
  LIFE_WHEEL_TOPICS.flatMap((topic) => {
    const score = scores[topic];
    if (!score || (score.current === 0 && score.target === 0)) {
      return [];
    }
    return [{ topic, current: score.current, target: score.target }];
  });
